<template>
  <v-dialog
    v-model="show"
    width="500"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2">
        {{ $t('conflict.startingAConflictResolution') }}
      </v-card-title>

      <v-card-text>
        {{ $t('conflict.preventDataLoseWhenStartingConflictResolution') }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click="$emit('cancel')"
        >
          {{ $t('global.cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          :loading="isLoading"
          @click="$emit('confirm')"
        >
          {{ $t('conflict.startResolution') }}
        </v-btn>
        
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: "warnClearResolutionDialog",

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    isLoading: {
      get () {
          return this.loading;
      },
      set (value) {
          this.$emit('update:loading', value);
      }
    },
    show: {
      get () {
          return this.open;
      },
      set (value) {
          this.$emit('update:open', value);
      }
    },
  }
}
</script>
